import React from "react";
import Hero from "../components/home/Hero";
import AdventureOverview from "../components/home/AdventureOverview";
import LearnMore from "../components/home/LearnMore";
import MountainExperience from "../components/home/MountainExperience";
import ProcessSection from "../components/home/ProcessSection";
import UpcomingExp from "../components/home/UpcomingExp";


const Home = () => {
  return (
    <>
      <Hero />
      <AdventureOverview />
      <ProcessSection />
      <MountainExperience />
      <UpcomingExp />
      <LearnMore />  
    </>
  );
};

export default Home;
